import { Routes } from '@angular/router';

import { AuthenticatedLayoutComponent } from './core/layout/components/authenticated-layout/authenticated-layout.component';
import { provideAiKnowledge } from './features/ai-knowledge/data-access-ai-knowledge/provider';
import { provideBankCard } from './features/bank-card/data-access-bank-card/provider';
import { provideLog } from './features/log/data-access-log/provider';
import { provideInvite } from './features/setting/data-access-invite';
import { provideSuborganization } from './features/setting/data-access-suborganization';
import { provideUser } from './features/user/data-access-users/provider';
import { authGuard, financeGuard, guestGuard, Role, roleGuard } from './shared/data-access/data-access-authentication';
import { provideKnowledge } from './shared/data-access/data-access-knowledge';
import { provideReport } from './shared/data-access/data-access-report/provider';

export const routes: Routes = [
  {
    path: '',
    canActivate: [guestGuard],
    canActivateChild: [guestGuard],
    loadChildren: () => import('./features/authentication/authentication.routes').then((lib) => lib.routes),
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadChildren: () => import('./features/onboarding/onboarding.routes').then((lib) => lib.routes),
  },
  {
    path: 'payment',
    canActivate: [authGuard],
    canMatch: [financeGuard],
    loadComponent: () =>
      import('./features/payment/pages/payment-landing/payment-landing.component').then(
        (lib) => lib.PaymentLandingComponent,
      ),
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    providers: [provideReport(), provideUser(), provideLog(), provideKnowledge()],
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((lib) => lib.routes),
      },
      {
        path: 'report',
        loadChildren: () => import('./features/report/report.routes').then((lib) => lib.routes),
      },
      {
        path: 'user',
        canMatch: [roleGuard],
        data: { roles: [Role.ADMIN, Role.ANALYST] },
        loadChildren: () => import('./features/user/user.routes').then((lib) => lib.routes),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./features/report/pages/create-report/create-report.component').then(
            (lib) => lib.CreateReportComponent,
          ),
      },
      {
        path: 'settings',
        providers: [provideInvite(), provideSuborganization()],
        loadChildren: () => import('./features/setting/setting.routes').then((lib) => lib.routes),
      },
      {
        path: 'activity-log',
        loadChildren: () => import('./features/log/log.routes').then((lib) => lib.routes),
      },
      {
        path: 'bank-cards',
        providers: [provideBankCard()],
        canMatch: [roleGuard],
        data: { roles: [Role.ADMIN] },
        loadChildren: () => import('./features/bank-card/bank-card.routes').then((lib) => lib.routes),
      },
      {
        path: 'knowledge',
        loadChildren: () => import('./features/knowledge/knowledge.routes').then((lib) => lib.routes),
      },
      {
        path: 'ai-knowledge',
        providers: [provideAiKnowledge()],
        canMatch: [roleGuard],
        data: { roles: [Role.ADMIN, Role.ANALYST] },
        loadChildren: () => import('./features/ai-knowledge/ai-knowledge.routes').then((lib) => lib.routes),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];
